// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"O_TheComp__IOkTE"};